import Section from './Section';
import SectionHeadline from './SectionHeadline';

export {
    SectionHeadline
};

export default Section;
